module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-getting-past-the-addicted-self@3x.862c5ef5.png";